import { render } from "./Customers.vue?vue&type=template&id=3292e528&ts=true"
import script from "./Customers.vue?vue&type=script&lang=ts"
export * from "./Customers.vue?vue&type=script&lang=ts"

import "./Customers.vue?vue&type=style&index=0&id=3292e528&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__